import { render, staticRenderFns } from "./Courts.vue?vue&type=template&id=a69e1fa6&scoped=true&"
import script from "./Courts.vue?vue&type=script&lang=js&"
export * from "./Courts.vue?vue&type=script&lang=js&"
import style0 from "./Courts.vue?vue&type=style&index=0&id=a69e1fa6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69e1fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSimpleTable,VSkeletonLoader})
